import {
  DATE_FIELD_SELECTED,
  DATE_PICKER_SELECTED,
  PERIOD_SELECTED_DAY,
  PERIOD_SELECTED_MONTH,
  PERIOD_SELECTED_WEEK,
  PERIOD_LAST_SELECTION,
} from './types/PeriodSelectionActionTypes';

export const dateFieldSelected = dateFieldValue => ({
  type: DATE_FIELD_SELECTED,
  dateField: dateFieldValue,
});

export const datePickerSelected = datePickerValue => ({
  type: DATE_PICKER_SELECTED,
  datePickerValue,
});

export const weekPeriodSelected = period => ({
  type: PERIOD_SELECTED_WEEK,
  ...period,
});
export const monthPeriodSelected = period => ({
  type: PERIOD_SELECTED_MONTH,
  ...period,
});
export const dayPeriodSelected = period => ({
  type: PERIOD_SELECTED_DAY,
  ...period,
});

export const storeLastPeriodSelection = period => ({
  type: PERIOD_LAST_SELECTION,
  ...period,
});
